import { Div, Text2 } from "components/Base";
import React from "react";
import { connect } from "react-redux";
import { getSubsessions } from "../../selectors";

const decorate = connect(state => ({
  subsessions: getSubsessions(state)
}));

const Subsession = ({ title, speakers, startsAt, endsAt }) => (
  <Div
    width={1}
    p={3}
    mb={2}
    display="column.flex-start.stretch"
    style={{ border: "1px solid #E7E6EA", borderRadius: "6px" }}
  >
    <Text2 bold mb={1.5}>
      {title}
    </Text2>
    <Div display="row.space-between.center">
      <Text2 width={0.6}>Speakers</Text2>
      <Text2 align="center" width={0.2}>
        Starts At
      </Text2>
      <Text2 align="center" width={0.2}>
        Ends At
      </Text2>
    </Div>
    <Div display="row.space-between.center">
      <Text2 width={0.6} bold>
        {speakers && speakers.length
          ? speakers.map(s => s.name).join(", ")
          : "-"}
      </Text2>
      <Text2 align="center" width={0.2} bold>
        {startsAt && startsAt.length ? startsAt : "-"}
      </Text2>
      <Text2 align="center" width={0.2} bold>
        {endsAt && endsAt.length ? endsAt : "-"}
      </Text2>
    </Div>
  </Div>
);

const Subsessions = ({ subsessions }) => {
  return (
    <Div pt={3} mb={10} width={1} display="column.flex-start.stretch">
      {subsessions.map(s => (
        <Subsession key={s.id} {...s} />
      ))}
    </Div>
  );
};

export default decorate(Subsessions);
